import type { ValueObject } from 'jsonld';
import { FindOperator } from '../FindOperator';

// eslint-disable-next-line @typescript-eslint/naming-convention
export function And<T extends number | Date | string | boolean | ValueObject>(value: T[]): FindOperator<T[], 'and'> {
  return new FindOperator({
    operator: 'and',
    value
  });
}
